import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { type ActionVariant, linkStyles } from '../-private/action-styles.ts';
import { default as IconComponent } from '../-private/components/link-or-button-icon.gts';
import type { Signature as IconSignature } from '../-private/components/link-or-button-icon';

export interface Signature {
  Element: HTMLAnchorElement;
  Args: {
    /**
     * The look of the link (default: `link`). The same names as WrButton and
     * WrAnchor: `primary`, `primary-white-border`, `outlined`,
     * `outlined-mini`, `link`, `inverted-link`.
     */
    variant?: ActionVariant;
    icon?: IconSignature['Args']['icon'];
    route?: string;
    models?: unknown[];
    model?: unknown;
    query?: Record<string, unknown>;
    ariaLabel?: string;
  };
  Blocks: {
    default: [];
  };
}

export default class WrLinkToComponent extends Component<Signature> {
  get styles() {
    return linkStyles(this.args.variant ?? 'link');
  }

  get query() {
    return this.args.query ?? {};
  }

  <template>
    {{#if @model}}
      <LinkTo
        @route={{@route}}
        @model={{@model}}
        @query={{this.query}}
        class={{this.styles}}
        aria-label={{@ariaLabel}}
        ...attributes
      >
        <IconComponent @icon={{@icon}} />
        {{yield}}
      </LinkTo>
    {{else if @models}}
      <LinkTo
        @route={{@route}}
        @models={{@models}}
        @query={{this.query}}
        class={{this.styles}}
        aria-label={{@ariaLabel}}
        ...attributes
      >
        <IconComponent @icon={{@icon}} />
        {{yield}}
      </LinkTo>
    {{else if @query}}
      <LinkTo
        @route={{@route}}
        @query={{this.query}}
        class={{this.styles}}
        aria-label={{@ariaLabel}}
        ...attributes
      >
        <IconComponent @icon={{@icon}} />
        {{yield}}
      </LinkTo>
    {{else if @route}}
      <LinkTo
        @route={{@route}}
        class={{this.styles}}
        aria-label={{@ariaLabel}}
        ...attributes
      >
        <IconComponent @icon={{@icon}} />
        {{yield}}
      </LinkTo>
    {{/if}}
  </template>
}
